// extracted by mini-css-extract-plugin
export default {"tags":"styles_tags__tgX9I"};